import React from "react"

import { PointsOfInterest } from "@/base/geo"
import { isNumberValid } from "@/base/type-guards"
import { getActiveFarmLat, getActiveFarmLng } from "@/redux/selectors"
import { getMapTypeValueFromState } from "@/redux/user-preferences.reducer"
import { useRootSelector } from "@/redux/useRootSelector"

interface Options
  extends Pick<google.maps.MapOptions, "gestureHandling" | "zoomControl"> {
  initialLat?: number
  initialLng?: number
  initialZoom?: number
}

export function useGoogleMapOptions(options?: Options) {
  const {
    gestureHandling,
    initialLat,
    initialLng,
    initialZoom = 14,
    zoomControl,
  } = options ?? {}
  const mapTypeId = useRootSelector(getMapTypeValueFromState)
  const farmLng = useRootSelector(getActiveFarmLng)
  const farmLat = useRootSelector(getActiveFarmLat)
  const mapOptions = React.useMemo((): google.maps.MapOptions => {
    let center = PointsOfInterest.CENTER_OF_USA.web
    if (isNumberValid(initialLat) && isNumberValid(initialLng)) {
      center = { lat: initialLat, lng: initialLng }
    } else if (isNumberValid(farmLat) && isNumberValid(farmLng)) {
      center = { lat: farmLat, lng: farmLng }
    }
    return {
      center,
      disableDefaultUI: true,
      gestureHandling,
      mapTypeId,
      zoom: initialZoom,
      zoomControl,
    }
  }, [
    farmLat,
    farmLng,
    gestureHandling,
    initialLat,
    initialLng,
    initialZoom,
    mapTypeId,
    zoomControl,
  ])
  return mapOptions
}
